import React, { useState } from 'react';
import { ArrowRightIcon, BellIcon, CheckIcon, ClockIcon, MapPinIcon, UsersIcon } from 'lucide-react';
import { activities, type Activity } from '../../data/loisirs';
const channels = ['Notification', 'SMS', 'Courriel'];
function AlertOptIn({
  label,
  confirmation
}: {
  label: string;
  confirmation: string;
}) {
  const [armed, setArmed] = useState(false);
  const [channel, setChannel] = useState(channels[0]);
  if (!armed) {
    return <button type="button" onClick={() => setArmed(true)} className="mt-auto inline-flex w-full items-center justify-center gap-2 rounded-full border border-ville-indigo px-5 py-2.5 text-sm font-bold text-ville-indigo transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1510" data-mp="pvdt9dkahzeg">
        <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-1511" data-mp="755xjgix6b8a" />
        {label}
      </button>;
  }
  return <div className="mt-auto rounded-2xl bg-ville-indigo-soft px-4 py-3" data-id="element-1512" data-mp="25t8qq8hmu32">
      <p className="flex items-start gap-2 text-sm font-semibold text-ville-indigo" data-id="element-1513" data-mp="2he9tzr3ce48d">
        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-1514" data-mp="2mculn24j3fl7" />
        {confirmation}
      </p>
      <div className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-1515" data-mp="2r5xdn5tnqgza">
        {channels.map(option => <button key={option} type="button" aria-pressed={channel === option} onClick={() => setChannel(option)} className={`rounded-full px-3 py-1 text-xs font-bold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo ${channel === option ? 'bg-ville-indigo text-white' : 'bg-white text-ville-navy'}`} data-id="element-1516" data-mp="2w2e2k28okzdf">
            {option}
          </button>)}
      </div>
    </div>;
}
function ActivityCard({
  activity,
  onRegister
}: {
  activity: Activity;
  onRegister: (activity: Activity) => void;
}) {
  return <article className="flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-1517" data-mp="1oplsdxbp3g0q">
      <img src={activity.image} alt="" className="h-40 w-full object-cover" data-id="element-1518" data-mp="1jrjzkkogw2c2" />
      <div className="flex flex-1 flex-col p-5" data-id="element-1519" data-mp="1xqtd1clagicc">
        <div className="flex items-start justify-between gap-3" data-id="element-1520" data-mp="1xpicdln53qpg">
          <h3 className="text-[17px] font-extrabold leading-tight text-ville-navy" data-id="element-1521" data-mp="1sr71d7l3za5n">{activity.name}</h3>
          {activity.state === 'complet' && <span className="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-600" data-id="element-1522" data-mp="152e1x15a2k6a">
              Complet
            </span>}
        </div>

        <ul className="mt-3 space-y-1.5 text-sm text-slate-600" data-id="element-1523" data-mp="1esphjkybqht0">
          <li className="flex items-center gap-2" data-id="element-1524" data-mp="1a1h6kkhciodq">
            <UsersIcon className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-1525" data-mp="19zwcsx2uv9gx" />
            {activity.audience}
          </li>
          <li className="flex items-center gap-2" data-id="element-1526" data-mp="hcjoahd4wrkz">
            <MapPinIcon className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-1527" data-mp="hbs21x5fg67d" />
            {activity.place}
          </li>
          <li className="flex items-center gap-2" data-id="element-1528" data-mp="2sy2cs4n725fg">
            <ClockIcon className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-1529" data-mp="2xrnd43c9fbht" />
            {activity.schedule}
          </li>
        </ul>

        <div className="mt-4 flex items-baseline justify-between gap-3" data-id="element-1530" data-mp="2jxdxl6m2dz0z">
          <p className="text-lg font-extrabold text-ville-navy" data-id="element-1531" data-mp="2oythgvci9zhs">{activity.price}</p>
          <p className="text-xs font-semibold text-slate-500" data-id="element-1532" data-mp="3cp7fr3looukt">{activity.availability}</p>
        </div>

        {activity.state === 'a-venir' && activity.opensOn && <p className="mt-3 rounded-xl bg-slate-50 px-3 py-2 text-xs font-semibold text-ville-navy" data-id="element-1533" data-mp="32q83zc5mgitl">
            Inscription dès le {activity.opensOn}
          </p>}

        <div className="mt-5 flex flex-1 flex-col justify-end gap-2" data-id="element-1534" data-mp="37qmagprkrkpi">
          {activity.state === 'ouvert' && <>
              <button type="button" onClick={() => onRegister(activity)} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1535" data-mp="1w9wdzycye793">
                S’inscrire
              </button>
              <button type="button" className="inline-flex items-center justify-center gap-1.5 text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1536" data-mp="2uiniirmp8flp">
                Voir l’activité
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1537" data-mp="2givxw81og0yq" />
              </button>
            </>}

          {activity.state === 'a-venir' && <AlertOptIn label="Me prévenir à l’ouverture" confirmation="ATNA vous préviendra dès l’ouverture des inscriptions." data-id="element-1538" data-mp="19zxp1ygo3ngp" />}

          {activity.state === 'complet' && <>
              <button type="button" className="inline-flex w-full items-center justify-center rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1539" data-mp="zzevu0oz5g1j">
                Me placer sur la liste d’attente
              </button>
              <AlertOptIn label="Me prévenir si une place se libère" confirmation="ATNA surveille les places et vous préviendra." data-id="element-1540" data-mp="1iqo5c9yqw4t4" />
              <p className="text-center text-xs text-slate-400" data-id="element-1541" data-mp="1sm9ecs28e5cd">Options d’inscription automatique à venir</p>
            </>}
        </div>
      </div>
    </article>;
}
interface ForYouProps {
  onRegister: (activity: Activity) => void;
}
export function ForYou({
  onRegister
}: ForYouProps) {
  return <section aria-labelledby="pour-vous-titre" className="mt-14" data-id="element-1542" data-mp="3mfslpzqa2nlo">
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-1543" data-mp="3hfwr2r3h08is">
        <div data-id="element-1544" data-mp="715jmch0xv9">
          <h2 id="pour-vous-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1545" data-mp="7j7mzlte6b3">
            Pour vous
          </h2>
          <p className="mt-1 text-[15px] text-slate-600" data-id="element-1546" data-mp="3revqrk69cttn">Des activités adaptées à votre profil et à votre famille.</p>
        </div>
        <button type="button" className="text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1547" data-mp="48cudpnitf2e">
          Voir toutes les activités
        </button>
      </div>

      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1548" data-mp="dyoa09gkhcp4">
        {activities.map(activity => <ActivityCard key={activity.id} activity={activity} onRegister={onRegister} data-id="element-1549" data-mp="rvba2l3tgiz9" />)}
      </div>
    </section>;
}